import { Component, OnInit } from '@angular/core';
import { config } from '@app/app.config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  version = config.version;
  constructor() { }

  ngOnInit() {
  }

}
